// "The API sent a value": 0 and '' count, so numeric node id 0 is not dropped by a truthiness check.
export const isPresent = (value) => value !== null && value !== undefined

// What both group-leader apps show for "the API sent nothing here". Named once so it can be
// swapped for a screen-reader-friendly cell in one place.
export const PLACEHOLDER = '-'
